// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
window.$h = (window.$h || {});
_.extend(window.$h, {
  singularize: function(text) {
    if (text.match(/(x|z|ch|sh|ss)es$/)) {
      return text.substring(0, text.length - 2);
    } else if (text.match(/s$/)) {
      return text.substring(0, text.length - 1);
    } else {
      return text;
    }
  },

  // Convert positive number less than 100b into 3 letter abbreviation
  abbreviateNumber: function (value){
    var newValue = value;
    if (value >= 1000) {
      var suffixes = ["", "K", "M", "B","T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = '';
      for (var precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
        var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
        if (dotLessShortValue.length <= 2) { break; }
      }
      if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  },

  decodeHTML: function(html) {
    var e = document.createElement('div');
    e.innerHTML = html;
    return e.childNodes[0].nodeValue;
    //return $('<div/>').html(html).text();
  },

  encodeHTML: function(unsafe) {
    return $('<div/>').text(unsafe).html();
  },

  truncate: function (str, max_length) {
    if (str.length > max_length)
      return str.slice(0, max_length - 3) + '…'
    else
      return str;
  },

  to_sentence: function(array) {
    switch(array.length) {
      case 0:
        return '';
      case 1:
        return '' + array[0];
      case 2:
        return '' + array[0] + ' and ' + array[1];
      default:
        return '' + array.slice(0, -1).join(', ') + ' and ' +
               array.slice(-1);
    }
  },

  be_verb: function(count) {
    return count === 1 ? 'is' : 'are';
  },
});
